import { Cart, FormattedCartItem, Service } from "../ducks/cart/cart-types";
import { FreeItem, Order, OrderDetailed } from "../types/server";

export type InvoiceType = {
  price: number;
  total_price: number;
  discount: number;
  logistic: number;
  free_items: FreeItem[];
  cash_back: number;
  vat: number;
  total_extra_charge: number;
};

export function invoice_generator(
  order: Order | OrderDetailed
): InvoiceType | undefined {
  if (!order) return undefined;

  let { price_descriptor } = order;
  let {
    logistic_price,
    total_items_amount,
    discount,
    free_items,
    total_amount,
    total_price,
    cash_back,
    vat,
    total_extra_charge,
  } = price_descriptor;

  return {
    logistic: logistic_price,
    discount,
    price: total_items_amount,
    total_price,
    free_items,
    cash_back,
    vat,
    total_extra_charge,
  };
}

function findPricingByVariationId(service: Service, variationId: string) {
  let wantedPricing = service.pricing.find((pricing) => {
    return variationId === pricing.variation.id;
  });

  return wantedPricing;
}

export function formatCartItems(data: Cart): FormattedCartItem[] {
  let output: FormattedCartItem[] = [];

  data?.services?.forEach((service) => {
    let service_id = service.id;
    let name = service.name;
    let alias = service.alias;
    let total_price = 0;
    let discount = {
      quantity: 0,
      total_discount: 0,
    };

    let variations_obj = {};

    // filter `service.items` and find only
    // related items to `service`
    let relatedItems = data.items.filter((cartItem) => {
      return cartItem.service === service_id;
    });

    relatedItems.forEach((relatedItem) => {
      let variationId = relatedItem.variation;

      if (relatedItem.discount > 0) {
        discount.quantity += 1;
        discount.total_discount += relatedItem.discount;
      }

      // We will find the `relatedItem`'s price and variation name
      let pricingInfo = findPricingByVariationId(service, variationId);

      if (pricingInfo) {
        total_price += pricingInfo.price;

        // Counting how many variations has been selected
        // for a specific service.
        let variationInVariationsObj = variations_obj[pricingInfo.variation.id];
        if (!variationInVariationsObj) {
          variations_obj[pricingInfo.variation.id] = {
            name: pricingInfo.variation.name,
            id: pricingInfo.variation.id,
            alias: pricingInfo.variation.alias,
            price: pricingInfo.price,
            quantity: 1,
          };
        } else {
          variations_obj[pricingInfo.variation.id].quantity += 1;
        }
      }
    });

    // Conver variations object to array
    let variations_ids = Object.keys(variations_obj);
    let variations = variations_ids.map((id) => variations_obj[id]);

    // output
    let item = {
      service_id,
      alias,
      name,
      total_price,
      discount,
      variations,
    };

    output.push(item);
  });

  return output;
}

export function formatOrderItem(data) {
  let output = [];

  data?.services?.forEach((service) => {
    let service_id = service.id;
    let name = service.name;
    let alias = service.alias;
    let total_price = 0;
    let discount = {
      quantity: 0,
      total_discount: 0,
    };

    let variations_obj = {};

    // filter `service.items` and find only
    // related items to `service`
    let relatedItems = data.items.filter((orderItem) => {
      return orderItem.service === service_id;
    });
    relatedItems.forEach((relatedItem) => {
      let variationId = relatedItem.variation;

      if (relatedItem.discount > 0) {
        discount.quantity += 1;
        discount.total_discount += relatedItem.discount;
      }

      // We will find the `relatedItem`'s price and variation name
      let itemPrice = relatedItem.price;
      total_price += itemPrice;

      // Counting how many variations has been selected
      // for a specific service.
      let variationInVariationsObj = variations_obj[variationId];

      if (!variationInVariationsObj) {
        let serviceVariation = service.pricing.find((h) => {
          return h.variation.id === variationId;
        });
        variations_obj[variationId] = {
          name: serviceVariation.variation.name,
          quantity: 1,
        };
      } else {
        variations_obj[variationId].quantity += 1;
      }
    });

    // Conver variations object to array
    let variations_ids = Object.keys(variations_obj);
    let variations = variations_ids.map((id) => variations_obj[id]);

    // output
    let item = {
      service_id,
      alias,
      name,
      discount,
      total_price,
      variations,
    };

    output.push(item);
  });

  return output;
}
